/* RESPONSIBLE TEAM: team-ai-agent */
import AutomationFinAIAgentProcedureSimulationsTestRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/procedure/preview/simulations/test';

export default AutomationFinAIAgentProcedureSimulationsTestRoute;
